// @flow
import { combineReducers } from 'redux';
import contractsReducer from './Contracts';

export type LegalDocumentsStateType = {||};

export default combineReducers({
  contracts: contractsReducer,
});
